<script lang="ts">
    import { Col,Badge } from "sveltestrap";
    import { BadgeExample } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" md="6">
    <Card cardProps="height-equal" cardHeaderprops="pb-0" headerTitle={BadgeExample}>
      <div slot="contentbody">
        <h1>heading <Badge color="primary">New</Badge></h1>
        <h2>heading <Badge color="primary">New</Badge></h2>
        <h3>heading <Badge color="primary">New</Badge></h3>
        <h4>heading <Badge color="primary">New</Badge></h4>
        <h5>heading <Badge color="primary">New</Badge></h5>
        <h6>heading <Badge color="primary">New</Badge></h6>
      </div>
    </Card>
</Col>